var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img_box",attrs:{"tabindex":"0"},on:{"click":_vm.goTo}},[_c('img',{attrs:{"src":_vm.data.bannerImg,"alt":_vm.data.imgAltText}})])}
var staticRenderFns = []

export { render, staticRenderFns }